import classNames from 'classnames'

import styles from './styles/Card.css'

const Card = ({ className = '', children, level = 1, ...rest }) => {
  return (
    <div
      className={classNames(styles.card, {
        [styles.levelZero]: level === 0,
        [styles.levelOne]: level === 1,
        [styles.levelTwo]: level === 2,
        [styles.levelThree]: level === 3,
        [styles.levelFour]: level === 4
      }, className)} {...rest}
    >
      {children}
    </div>
  )
}

export default Card
